<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <KTCodePreview
                    v-bind:title="'Pertanyaan Kuisioner Tingkat Kepuasan Taruna'"
                >
                    <template v-slot:toolbar>
                        <ButtonComponent
                            colors="#3751E4"
                            name="tambah"
                            v-b-modal.modal
                            @click.native="openModal('Tambah')"
                        />
                    </template>
                    <template v-slot:body>
                        <v-card>
                            <v-card-title>
                                <v-spacer></v-spacer>
                                <v-text-field
                                    v-model="code4.search"
                                    label="Search"
                                    single-line
                                    hide-details
                                ></v-text-field>
                            </v-card-title>
                            <v-data-table
                                :headers="code4.headers"
                                :items="code4.data"
                                :search="code4.search"
                            >
                                <template
                                    v-slot:[`item.statusPertanyaan`]="{ item }"
                                >
                                    <b-badge
                                        v-if="
                                            item.statusPertanyaan === 'Publish'
                                        "
                                        class="mr-1"
                                        variant="primary"
                                        style="font-size: revert"
                                        >Publish</b-badge
                                    >
                                    <b-badge
                                        v-else
                                        class="mr-1"
                                        variant="danger"
                                        style="font-size: revert"
                                        >Private</b-badge
                                    >
                                </template>
                                <template v-slot:[`item.action`]="{ item }">
                                    <ButtonComponent
                                        colors="#3751E4"
                                        name="edit"
                                        v-b-modal.modal
                                        @click.native="openModal('Edit', item)"
                                    />
                                    <ButtonComponent
                                        colors="#EF4848"
                                        name="hapus"
                                        @click.native="deleteData(item.key)"
                                    />
                                </template>
                            </v-data-table>
                        </v-card>
                    </template>
                </KTCodePreview>

                <b-modal
                    ref="modal"
                    ok-title="Simpan"
                    ok-variant="primary"
                    cancel-title="Batal"
                    cancel-variant="danger"
                    id="modal"
                    @ok="onSubmit"
                    :title="`${statusModal} Pertanyaan Kuisioner Tingkat Kepuasan Taruna AD`"
                >
                    <b-form>
                        <b-form-group
                            label="Pertanyaan"
                            label-for="input-pertanyaan"
                        >
                            <b-form-textarea
                                id="input-pertanyaan"
                                v-model="form.pertanyaan"
                                placeholder="Tuliskan Pertanyaan...."
                                rows="3"
                                max-rows="6"
                            ></b-form-textarea>
                        </b-form-group>
                        <b-form-group
                            label="Status"
                            v-slot="{ ariaDescribedby }"
                        >
                            <b-form-radio-group
                                id="radio-group-2"
                                v-model="form.statusPertanyaan"
                                :aria-describedby="ariaDescribedby"
                                name="radio-sub-component"
                                ><b-form-radio
                                    :aria-describedby="ariaDescribedby"
                                    name="some-radios"
                                    value="t"
                                    >Publish</b-form-radio
                                >
                                <b-form-radio
                                    :aria-describedby="ariaDescribedby"
                                    name="some-radios"
                                    value="f"
                                    >Unpublish</b-form-radio
                                ></b-form-radio-group
                            >
                        </b-form-group>
                    </b-form>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import KTCodePreview from '@/view/content/CardContent.vue';
import ButtonComponent from '@/view/content/components/button/buttonComponent.vue';
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module';
import { directive } from '@coders-tm/vue-number-format';
import axios from 'axios';

export default {
    data() {
        return {
            code4: {
                search: '',
                headers: [
                    {
                        text: 'No',
                        value: 'no',
                        align: 'center',
                        class: 'header-color',
                    },
                    {
                        text: 'Pertanyaan',
                        value: 'pertanyaan',
                        align: 'left',
                        class: 'header-color',
                    },
                    {
                        text: 'Status',
                        value: 'statusPertanyaan',
                        align: 'center',
                        class: 'header-color',
                    },
                    {
                        text: 'Aksi',
                        value: 'action',
                        align: 'center',
                        class: 'header-color',
                    },
                ],
                data: [],
            },
            statusModal: '',
            number: {
                decimal: ',',
                separator: '.',
                prefix: ' ',
                precision: 2,
                masked: false,
            },
            form: {
                key: null,
                pertanyaan: '',
                statusPertanyaan: '',
            },
            selectedStatus: '',
        };
    },
    components: {
        KTCodePreview,
        ButtonComponent,
    },
    directives: {
        number: directive,
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [{ title: 'Evaluasi Taruna' }]);

        this.getData();
    },
    methods: {
        openModal(status, itemData = null) {
            this.statusModal = status;

            // Reset Form
            this.form = {
                key: null,
                pertanyaan: '',
                statusPertanyaan: '',
            };

            if (status == 'Edit') {
                this.form.key = itemData.key;
                this.form.pertanyaan = itemData.pertanyaan;
                this.form.statusPertanyaan =
                    itemData.statusPertanyaan === 'Publish' ? 't' : 'f';
            }
        },
        hideModal() {
            this.$refs['modal'].hide();
        },
        onSubmit(event) {
            event.preventDefault();

            const form = this.form;

            if (form.key === null) {
                this.storeData(form);
            } else {
                this.updateData(form);
            }
        },
        refreshData(result, alert) {
            if (result.data.meta.code == 200) {
                this.hideModal();
                this.$swal(`Success ${alert} Data`);
                this.getData();
            } else {
                this.$swal(`Failed`);
            }
        },
        async getData() {
            let result = await axios.get(
                'survey-kepuasan/taruna/pertanyaan/index'
            );

            const data = result.data.data.pertanyaan;

            if (data.length > 0) {
                this.code4.data = [];
            }

            data.map((item, index) => {
                let obj = {
                    no: index + 1,
                    key: item.key,
                    pertanyaan: item.pertanyaan,
                    statusPertanyaan:
                        item.status === true ? 'Publish' : 'Private',
                };
                this.code4.data.push(obj);
            });
        },
        async storeData(form) {
            try {
                var formData = {
                    pertanyaan: form.pertanyaan,
                    status: form.statusPertanyaan,
                };

                let result = await axios.post(
                    'survey-kepuasan/taruna/pertanyaan/save',
                    formData
                );

                this.refreshData(result, 'Save');
            } catch (error) {
                this.$swal(`Failed`);
            }
        },
        async updateData(form) {
            try {
                var formData = {
                    key: form.key,
                    pertanyaan: form.pertanyaan,
                    status: form.statusPertanyaan,
                };

                let result = await axios.put(
                    `survey-kepuasan/taruna/pertanyaan/update/${form.key}`,
                    formData
                );

                this.refreshData(result, 'Update');
            } catch (error) {
                this.$swal(`Failed`);
            }
        },
        async deleteData(key) {
            try {
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You will not be able to recover this item!',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, cancel!',
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                }).then(async (result) => {
                    if (result.value) {
                        let result = await axios.delete(
                            `survey-kepuasan/taruna/pertanyaan/delete/${key}/`
                        );

                        this.refreshData(result, 'Delete');
                    }
                });
            } catch (error) {
                this.$swal('Failed');
            }
        },
    },
};
</script>

<style>
.header-color {
    background-color: #3751e4 !important;
    color: white !important;
    font-size: small !important;
    font-weight: 500 !important;
}
</style>
